module.exports = __webpack_public_path__ + "static/media/20.34e6de2e.svg";